'use client'

import Giscus from '@giscus/react'
import { clsx } from 'clsx'
import SiteConfig from 'config'
import styles from './Comments.module.scss'

type Props = {
  className: string
  giscusTerm: string
}

const Comments = ({ className, giscusTerm }: Props) => {
  if (!SiteConfig.giscus.enabled) return null

  return (
    <div className={clsx(className, styles['giscus-container'])}>
      <Giscus term={giscusTerm} {...SiteConfig.giscus} />
    </div>
  )
}

export default Comments
